import {currency, getCat, getFreq, getLegal, getShort} from "@/plugins/cats";
import moment from 'moment'

export default {
    methods: {
        r(num, X=1) {
            const n = +(Math.round(num + "e+"+X)  + "e-"+X);
            if (isNaN(n)){
                return "-"
            }
            else{
                return n
            }
        },
        getFreq(i){
            return getFreq(i)
        },
        getFreqNa(i){
            if(typeof i !== 'string'){
                return '<span style="color:#aaaaaa">n/a</span>'
            }
            return getFreq(i)
        },
        getShort(i){
            return getShort(i)
        },
        currency(i,q){
            return currency(i,q)
        },
        gcats(i){
            return getCat(i)
        },
        glegal(i){
            return getLegal(i)
        },
        isisin(s){
           if(!s || s.includes("-")){
               return "n/a"
           }
           else{
               return s
           }
        },
        isnum(n){
            if(isNaN(n)){
                return "-"
            }
            else{
                return n
            }
        },
        parseNA(i){
            if(isNaN(i)){
                return "-"
            }
            return (i/1000000).toFixed(1)
        },
        color(v){
            if(v < 0){
                return 'red'
            }
            else{
                return 'black'
            }
        },
        timeSince(d) {
            const since = new Date(d)
            const seconds = Math.floor((new Date() - since) / 1000);
            const interval = seconds / 31536000;
            if (interval > 1) {
                return Math.floor(interval) + " years";
            }
        },
        getDayOfYear(d) {
            return Math.ceil(moment().diff(moment(d), 'years', true));
        },
        convertURL(text) {
            const url = text.toLowerCase().trim().replaceAll('&', 'and').replace(/\s/g, '-');
            return encodeURI(url);
        },
        handleScroll() {
            let subRight = this.$refs.subRight;
            let subRightBefore = this.$refs.subRight_before;
            if (subRightBefore && subRight) {
              if(window.scrollY > subRightBefore.offsetHeight - subRight.offsetHeight && window.scrollY > 0) {
                subRight.classList.add("banner-under-bottom");
                subRight.style.top = `${subRightBefore.offsetHeight - subRight.offsetHeight + subRightBefore.offsetTop}px`
              }
              else {
                  subRight.classList.remove("banner-under-bottom");
                  subRight.style.top = '';
              }
            }
        },
        formatDateTime(dateTime, formatTime = 'DD MMM Y') {
            return moment(dateTime).format(formatTime)
        }
    }
}
